import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusTotal = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Total</title>
        <path
          d="M19.7288 7.0596L6.54883 19.7496L6.17883 20.0996C5.88883 20.3796 5.55883 20.5596 5.15883 20.5496C4.75883 20.5496 4.42883 20.4296 4.16883 20.1696L2.05883 18.1496C1.50883 17.6296 0.95883 17.0996 0.40883 16.5696C-0.13117 16.0596 -0.13117 15.2796 0.37883 14.7696C0.91883 14.2196 1.72883 14.1696 2.29883 14.6796C3.18883 15.4896 4.05883 16.3196 4.91883 17.1596C5.09883 17.3296 5.18883 17.3096 5.34883 17.1596L6.14883 16.3896L17.7588 5.1996C18.4488 4.5396 19.4988 4.6796 19.9688 5.4196C20.3788 5.9796 20.2088 6.5896 19.7188 7.0596H19.7288Z"
          fill="#4EAE36"
        />
        <path
          d="M17.6788 2.1796L6.59884 12.8496L6.28884 13.1496C6.04884 13.3896 5.76884 13.5396 5.42884 13.5296C5.08884 13.5296 4.81884 13.4296 4.58884 13.2096L2.80884 11.5096C2.33884 11.0696 1.87884 10.6296 1.41884 10.1796C0.968839 9.7496 0.968839 9.0896 1.39884 8.6596C1.84884 8.1996 2.52884 8.1496 3.00884 8.5896C3.75884 9.2696 4.48884 9.9696 5.21884 10.6796C5.36884 10.8196 5.43884 10.8096 5.57884 10.6796L6.24884 10.0296L16.0288 0.619599C16.6088 0.0595994 17.4888 0.179599 17.8888 0.799599C18.2288 1.2696 18.0888 1.7896 17.6788 2.1796Z"
          fill="#4EAE36"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusTotal;
